import { useState, useEffect } from "react";
import axios from "axios";
import Table from "react-bootstrap/Table";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { format } from "date-fns";
import "../assets/css/ConfigPage.css";
import "react-datepicker/dist/react-datepicker.css";
import DataTable from "datatables.net-dt";
import { useNavigate } from "react-router-dom";


const DashboardControl = (props) => {
  const { statusMode, setStatusMode, isLoggedIn } = props;
  const navigate = useNavigate();


  
  const [users, setUsers] = useState([]);
  const [cupomName, setCupomName] = useState("");
  const [cupomValue, setCupomValue] = useState("");
  const [cupomCreated, setCupomCreated] = useState(false);
  const [cupons, setCupons] = useState([]);
  const [cupomCreationDate, setCupomCreationDate] = useState("");
  const [cupomValidity, setCupomValidity] = useState("");
  const [activeTab, setActiveTab] = useState("status");
  const [periodos, setPeriodos] = useState([]);
  const [modalidades, setModalidades] = useState([]);
  const [userCounts, setuserCounts] = useState({});
  const [totalUsers, setTotalUsers] = useState(0);

  const [tabelaModalidadess, setTabelaModalidadess] = useState({
    Light: {
      Mensal: 0,
      Trimestral: 0,
      Anual: 0,
    },
    Pro: {
      Mensal: 0,
      Trimestral: 0,
      Anual: 0,
    },
    "Ao Vivo": {
      Mensal: 0,
      Trimestral: 0,
      Anual: 0,
    },
    Profissional: {
      Mensal: 0,
      Trimestral: 0,
      Anual: 0,
    },
  });
  const [tabelaModalidades, setTabelaModalidades] = useState({
    Light: {
      Mensal: 0,
      Trimestral: 0,
      Anual: 0,
    },
    Pro: {
      Mensal: 0,
      Trimestral: 0,
      Anual: 0,
    },
    "Ao Vivo": {
      Mensal: 0,
      Trimestral: 0,
      Anual: 0,
    },
    Profissional: {
      Mensal: 0,
      Trimestral: 0,
      Anual: 0,
    },
  });
  
  
  const handleSetActiveTab = (tab) => {
    setActiveTab(tab);
  };
  

  
  const loadData = async (url, setState) => {
    try {
      const response = await axios.get(url);
      setState(response.data);
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
    }
  };

  

  const deleteCupon = (userId) => {
    axios
      .delete(`https://rd.vps.webdock.cloud:9512/cupon/${userId}`)
      .then(() => {
        loadData("https://rd.vps.webdock.cloud:9512/cupons", setCupons);
      });
  };

  const createCupom = async (e) => {
    e.preventDefault();
    if (!cupomName || !cupomValue || !cupomCreationDate || !cupomValidity) {
      alert("Por favor, preencha todos os campos do cupom.");
      return;
    }

    axios
      .post("https://rd.vps.webdock.cloud:9512/gerarcupom", {
        nome: cupomName,
        valor_desconto: cupomValue,
        data_criacao: cupomCreationDate,
        validade: cupomValidity,
      })
      .then((response) => {
        setCupomCreated(true);
        setCupomName("");
        setCupomValue("");
        setCupomCreationDate("");
        setCupomValidity("");
        loadData("https://rd.vps.webdock.cloud:9512/cupons", setCupons);
      })
      .catch((error) => {
        console.error("Erro ao criar o cupom:", error);
      });
  };
  useEffect(() => {
    loadData("https://rd.vps.webdock.cloud:9512/cupons", setCupons);
  }, []);

  useEffect(() => {
    const FectDataCInterval = setInterval(() => {
      let table = new DataTable("#myTable");
    }, 1000);
    return () => clearInterval(FectDataCInterval);
  }, []);

  
  useEffect(() => {
    const FectDataCInterval = setInterval(() => {
      countUsersOverTime(users);
    }, 1000);

    const countUsers = () => {
      let counts = Array(12).fill(0);
      users.forEach((user) => {
        const month = new Date(user.data_cadastro).getMonth();
        counts[month]++;
      });
      return counts;
    };

    const userCounts = countUsers();
    setuserCounts(userCounts);
    setTotalUsers(userCounts.reduce((total, count) => total + count, 0));
    return () => clearInterval(FectDataCInterval);
  }, [users]);

  
  const countUsersOverTime = (users) => {
    const userCountsResult = Array(12).fill(0);
    const tabelaModalidadesResult = {
      Light: { Mensal: 0, Trimestral: 0, Anual: 0 },
      Pro: { Mensal: 0, Trimestral: 0, Anual: 0 },
      "Ao Vivo": { Mensal: 0, Trimestral: 0, Anual: 0 },
      Profissional: { Mensal: 0, Trimestral: 0, Anual: 0 },
    };
    const tabelaModalidadesResults = {
      Light: {
        mensallight: 0,
        trimestrallight: 0,
        anuallight: 0,
      },
      Pro: {
        mensalpro: 0,
        trimestralpro: 0,
        anualpro: 0,
      },
      "Ao Vivo": {
        mensalaovivo: 0,
        trimestralaovivo: 0,
        anualaovivo: 0,
      },
      Profissional: {
        mensalprofissional: 0,
        trimestralprofissional: 0,
        anualprofissional: 0,
      },
    };
    const mapeamentoPlanos = {
      "Arbritagem Bet Light Mensal ": "mensallight",
      "Arbritagem Bet Light Mensal": "mensallight",
      "Arbritagem Bet Pro Mensal": "mensalpro",
      "Arbritagem Bet Ao vivo Mensal": "mensalaovivo",
      "Arbritagem Bet Profissional Mensal": "mensalprofissional",

      "Arbritagem Bet Light Trimestral": "trimestrallight",
      "Arbritagem Bet Pro Trimestral": "trimestralpro",
      "Arbritagem Bet Ao vivo Trimestral": "trimestralaovivo",
      "Arbritagem Bet Profissional Trimestral": "trimestralprofissional",

      "Arbritagem Bet Light Anual": "anuallight",
      "Arbritagem Bet Pro Anual": "anualpro",
      "Arbritagem Bet Ao vivo Anual": "anualaovivo",
      "Arbritagem Bet Profissional Anual": "anualprofissional",
    };

  
    users.forEach((user) => {
      const tipoPlano = user.tipo_de_plano;

      for (const modalidade in tabelaModalidadesResults) {
        if (
          tabelaModalidadesResults[modalidade][mapeamentoPlanos[tipoPlano]] >= 0
        ) {
          tabelaModalidadesResults[modalidade][mapeamentoPlanos[tipoPlano]]++;
        }
      }
    });

    
    users.forEach((user) => {
      const registrationDate = new Date(user.data_cadastro);
      const month = registrationDate.getMonth();
      userCountsResult[month]++;
    });
    
    const periodosResult = ["Mensal", "Trimestral", "Anual"];
    const modalidadesResult = Object.keys(tabelaModalidadesResult);

    setPeriodos(periodosResult);
    setModalidades(modalidadesResult);
    setTabelaModalidades(tabelaModalidadesResults);

    return userCountsResult;
  };
  
  const labels = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  
  return (
    <>
      <div className="config-wrappers">
        <div className="main-content">
          {activeTab === "status" && (
            <div className="status-card body-carduser">
              <div className="status-header">
                <div className="bodysidebar">
                  <div
                    className="sidebar-item"
                    onClick={() => handleSetActiveTab("status")}
                  >
                    Dashboard
                  </div>
                  <div
                    className="sidebar-item"
                    onClick={() => navigate("/dashboard/users")}
                  >
                    Usuarios
                  </div>
                  <div
                    className="sidebar-item"
                    onClick={() => handleSetActiveTab("downloads")}
                  >
                    Controle Afiliados
                  </div>

                  <div
                    className="sidebar-item"
                    onClick={() => navigate("/bonus/list")}
                  >
                    Calculadora Bônus
                  </div>
                </div>
                <h3 className={` ${statusMode ? "text-light" : "textDark"}`}>
                  Dashboard Sistema
                </h3>
              </div>
              <div className="status-info">
                <div className="dadosconta">
                  <div className="statusconta"></div>
                  <div className="planoconta">
                    <p
                      className={` ${statusMode ? "text-light" : "textDark"}`}
                    ></p>
                  </div>

                  <h3> Graficos Quantidade de Usuarios</h3>
                  <div className="graficoqtdusuarios">
                    <Table
                      defaultActiveKey="home"
                      id="justify-tab-example"
                      striped
                      bordered
                      hover
                      className={`tabledashboard mb-3 ${
                        statusMode ? "dark-mode" : ""
                      }`}
                    >
                      <thead>
                        <tr>
                          <th>Total de Usuários</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          className={`${statusMode ? "tr-dark" : "tr-white"}`}
                        >
                          <td>{totalUsers}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>

                  <h3> Graficos Registro Quantidade de Usuarios por mês</h3>
                  <div className="graficoqtdusuariosregistrerdia">
                    <Table
                      defaultActiveKey="home"
                      id="justify-tab-example"
                      striped
                      bordered
                      hover
                      className={`tabledashboard mb-3 ${
                        statusMode ? "dark-mode" : ""
                      }`}
                    >
                      <thead>
                        <tr>
                          {labels.map((label) => (
                            <th key={label}>{label}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          className={`${statusMode ? "tr-dark" : "tr-white"}`}
                        >
                          {Array.isArray(userCounts) &&
                            userCounts.map((count, index) => (
                              <td key={index}>{count}</td>
                            ))}
                        </tr>
                      </tbody>
                    </Table>
                  </div>

                  <h3> Registro tipo de Plano</h3>
                  <div className="graficoqtdusuariosregistrerdia">
                    <table className="table table-striped table-bordered table-hover tabledashboard">
                      <thead>
                        <tr>
                          <th></th>
                          {Object.keys(tabelaModalidadess.Light).map(
                            (periodo) => (
                              <th>{periodo}</th>
                            )
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(tabelaModalidades).map((modalidade) => (
                          <tr key={modalidade} className="tr-dark">
                            <th>{modalidade}</th>
                            {Object.keys(tabelaModalidades[modalidade]).map(
                              (periodo) => (
                                <td key={periodo}>
                                  {tabelaModalidades[modalidade][periodo]}
                                </td>
                              )
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}
         
          {activeTab === "downloads" && (
            <div className="downloads-card body-carduser">
              <div className="status-header">
                <div className="bodysidebar">
                  <div
                    className="sidebar-item"
                    onClick={() => handleSetActiveTab("status")}
                  >
                    Dashboard
                  </div>
                  <div
                    className="sidebar-item"
                    onClick={() => navigate("/dashboard/users")}
                  >
                    Usuarios
                  </div>
                  <div
                    className="sidebar-item"
                    onClick={() => handleSetActiveTab("downloads")}
                  >
                    Controle Afiliados
                  </div>
                  <div
                    className="sidebar-item"
                    onClick={() => navigate("/bonus/list")}
                  >
                    Calculadora Bônus
                  </div>
                </div>
                <h3 className={` ${statusMode ? "text-light" : "textDark"}`}>
                  Área de Downloads
                </h3>
              </div>
              <hr />
              <Form className="containerdashboard">
                <h3>Criar Cupom de Desconto</h3>
                <FloatingLabel controlId="cupomName" label="Nome do Cupom">
                  <Form.Control
                    type="text"
                    placeholder="Nome do Cupom"
                    value={cupomName}
                    onChange={(e) => setCupomName(e.target.value)}
                  />
                </FloatingLabel>
                <FloatingLabel controlId="cupomValue" label="% do Desconto">
                  <Form.Control
                    type="number"
                    placeholder="Valor do Desconto"
                    value={cupomValue}
                    step="0.01"
                    onChange={(e) => setCupomValue(e.target.value)}
                  />
                </FloatingLabel>
                <FloatingLabel
                  controlId="cupomCreationDate"
                  label="Data de Criação"
                >
                  <Form.Control
                    type="date"
                    placeholder="Data de Criação"
                    value={cupomCreationDate}
                    onChange={(e) => setCupomCreationDate(e.target.value)}
                  />
                </FloatingLabel>
                <FloatingLabel controlId="cupomValidity" label="Validade">
                  <Form.Control
                    type="date"
                    placeholder="Validade"
                    value={cupomValidity}
                    onChange={(e) => setCupomValidity(e.target.value)}
                  />
                </FloatingLabel>

                <button className="btn-dashboard" onClick={createCupom}>
                  Criar Cupom
                </button>
              </Form>
              <hr />
              {cupomCreated && (
                <ToastContainer position="top" className="p-3">
                  <Toast
                    bg="success"
                    onClose={() => setCupomCreated(false)}
                    show={cupomCreated}
                    delay={3000}
                    autohide
                  >
                    <Toast.Header>
                      <strong className="me-auto">Cupom Criado</strong>
                    </Toast.Header>
                    <Toast.Body>O cupom foi criado com sucesso!</Toast.Body>
                  </Toast>
                </ToastContainer>
              )}
              <hr />
              <h3>Lista de Cupons</h3>
              <Table
                striped
                bordered
                hover
                className={`tabledashboard mb-3 ${
                  statusMode ? "dark-mode" : ""
                }`}
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nome do Cupom</th>
                    <th>% do Desconto</th>
                    <th>Data de Criação</th>
                    <th>Validade</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {cupons.map((cupom) => (
                    <tr
                      className={`${statusMode ? "tr-dark" : "tr-white"}`}
                      key={cupom.id}
                    >
                      <td>{cupom.id}</td>
                      <td>{cupom.nome}</td>
                      <td>{cupom.valor_desconto}</td>
                      <td>
                        {format(new Date(cupom.data_criacao), "dd/MM/yyyy")}
                      </td>
                      <td>{format(new Date(cupom.validade), "dd/MM/yyyy")}</td>
                      <td>
                        <button
                          style={{
                            background: "red",
                            color: "white",
                            padding: "5px",
                          }}
                          onClick={() => deleteCupon(cupom.id)}
                        >
                          Excluir
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
          {activeTab === "suporte" && (
            <div className="support-card body-carduser">
              <div className="status-header">
                <h3>Suporte</h3>
              </div>

              <p>Para obter suporte, entre em contato pelo WhatsApp.</p>
              <Button
                className={` ${statusMode ? "text-light" : "textDark"}`}
                variant="success"
                href="https://api.whatsapp.com/send?phone=SEU_NUMERO_DE_WHATSAPP"
              >
                Contatar Suporte via WhatsApp
              </Button>
            </div>
          )}
          {activeTab === "sair" && (
            <div className="body-carduser">
              <div className="status-header">
                <h1 className={` ${statusMode ? "text-light" : "textDark"}`}>
                  Desconectar
                </h1>
              </div>

              <hr />

              <li className="nav-link">
                <span className="navlink">
                  <a className="linknavbar">
                    <b
                      className={` ${statusMode ? "text-light" : "textDark"}`}
                    ></b>
                  </a>
                </span>
              </li>
            </div>
            
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardControl;